import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import SettingEdit from './SettingEdit/SettingEdit';

const Settings = ({ match }) => {
    return (
        <div className="Settings">
            <ContainerWrapper container="settings">
                <Route path={ `${ match.url }/edit/:settingId/:field?` } component={SettingEdit} />
            </ContainerWrapper>
        </div>
    );
}

export default Settings;
